<template>
  <Fragment>
    <div class="page" :class="newSkin ? ' new-skin' : ''">
      <PreLoader />
      <Gradient/>
      <div
        class="container opened"
        :data-animation-in="animationFunction.animationIn"
        :data-animation-out="animationFunction.animationOut"
      >
        <slot />
      </div>
      <Sidebar v-if="!noSidebar" />
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import { animationFunction } from "@/animationsReactive";
import PreLoader from "./preloader";
import Gradient from "@/components/backgrounds/gradient";
import Sidebar from "@/layouts/sidebar";
export default {
  name: "layout",
  components: {
    Fragment,
    PreLoader,
    Gradient,
    Sidebar,
  },
  data() {
    return {
      animationFunction
    };
  },
  props: {
    background: {
      type: String,
      default: "none"
    },
    backgroundImg: { type: String },
    newSkin: {
      type: Boolean,
      default: true
    },
    noSidebar: { type: Boolean }
  }
};
</script>

<style scoped></style>
